import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Menu,
  MenuItem
} from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import SettingsIcon from '@mui/icons-material/Settings';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as Logo } from './logo.svg';
import './NavbarStyles.css';

// eslint-disable-next-line react/prop-types
function Navbar({ env, audience, token }) {
  const propsToPass = {
    env,
    audience,
    token
  };
  const navigate = useNavigate();

  const handleLogout = () => navigate('/', { state: null });
  const handleHome = () => navigate('/stores', { state: propsToPass });

  const [anchorEl, setAnchorEl] = useState(null);
  const [isRotated, setIsRotated] = useState(false);

  const handleMenuOpen = (event) => {
    setIsRotated(true);
    setAnchorEl(event.currentTarget);
    setTimeout(() => setIsRotated(false), 300);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleHelpClick = () => {
    window.open('https://developer.snapfinance.com/', '_blank');
  };

  return (
    <AppBar position="static">
      <Toolbar className="stores-toolbar">
        <Logo className="store-logo" />
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <Typography variant="subtitle2">Welcome to Demo Stores</Typography>
          <Typography variant="body2" color="white">
            Environment: {env}
          </Typography>
        </div>

        <div style={{ marginLeft: 'auto' }}>
          <IconButton
            color="inherit"
            aria-label="help"
            onClick={handleHelpClick}
          >
            <HelpOutlineIcon />
            <span className="store-help">Need Help?</span>
          </IconButton>
          <IconButton
            color="inherit"
            aria-label="settings"
            onClick={handleMenuOpen}
          >
            <SettingsIcon
              className={isRotated ? 'rotated' : ''}
              style={{ transition: 'transform 0.3s ease' }}
            />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
          >
            <MenuItem onClick={handleHome}>Home</MenuItem>
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
          </Menu>
        </div>
      </Toolbar>
    </AppBar>
  );
}

export default Navbar;
